import './AchievementsBlock.scss';

interface AchievementsBlockProps {
  achievementDataArray: any[]
};

const AchievementsBlock = (props: AchievementsBlockProps) => {
  return (
    <>
      <div className='export-row'>
        {props.achievementDataArray.filter((_, idx) => {
          const half = Math.ceil(props.achievementDataArray.length / 2);
          return idx < half;
        }).map((elem, idx) => {
          const displayValue = parseFloat(elem.value.toFixed(3));
          return (
            <div key={'export-homepage-r1-' + idx} className='topic-block'>
              <div className='icon-wrapper'>
                <img src={elem.icon} alt={elem.altText} />
              </div>
              <h1>{displayValue + '' + (elem.unit ? elem.unit : '')}</h1>
              <p>{elem.title}</p>
            </div>
          );
        })}
      </div>
      <div className='export-row'>
        {props.achievementDataArray.filter((_, idx) => {
          const half = Math.ceil(props.achievementDataArray.length / 2);
          return idx >= half;
        }).map((elem, idx) => {
          const displayValue = parseFloat(elem.value.toFixed(3));
          return (
            <div key={'export-homepage-r2-' + idx} className='topic-block'>
              <div className='icon-wrapper'>
                <img src={elem.icon} alt={elem.altText} />
              </div>
              <h1>{displayValue + '' + (elem.unit ? elem.unit : '')}</h1>
              <p>{elem.title}</p>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default AchievementsBlock;